class OntarioObstetricalSecondAndThirdTrimesterLab {
    public Hemoglobin: string;
    public BloodGroup: string;
    public BloodRhesus: string;
    public Platelets: string;
    public RepeatAntibodies: string;
    public FirstHourGlucoseChallengeTest: string;
    public SecondHourGlucoseToleranceTest: string;

    constructor(fields?: Partial<OntarioObstetricalSecondAndThirdTrimesterLab>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalSecondAndThirdTrimesterLab };
